import { BroadcastChannel } from 'broadcast-channel';
import { EVENT_KEYS } from 'consts/data';
import { detectBrowserHidden } from 'helpers';

class Broadcast {
  channelSwitchUser() {
    return {
      initListener: () => {
        //* TA-2826
        //* Execute function when switch user
        //* If tab is inactive -> reload web to re-get token
        const channel = new BroadcastChannel(EVENT_KEYS.loginAsUser);
        channel.addEventListener('message', (event) => {
          const { isHidden } = detectBrowserHidden();
          if (isHidden) {
            window.location.reload();
          }
        });

        window.addEventListener('message', (event) => {
          //* In case user logout or switch user cross window
          if (event.key === EVENT_KEYS.loginAsUser) {
            window.location.reload();
          }
        });
      },

      postMessageReload: () => {
        const channel = new BroadcastChannel(EVENT_KEYS.loginAsUser);
        channel.postMessage(EVENT_KEYS.loginAsUser);
      },
    };
  }
}

export default new Broadcast();
